import React, { useEffect } from 'react'
import getConfig from 'next/config'
import Head from 'next/head'
import GeneralImageHero from '../../components/GeneralImageHero'
import PageTitle from '../../components/PageTitle'
import { InferGetServerSidePropsType } from 'next'
import Image from 'next/image'
import { defaultLoader } from '../../utils/custom-image-loader'
import NestedImage from '../../components/NestedImage'
import { setPageViewData } from '../../utils/analytics'

const StaticPage = ({ staticPage, fullUrl, slug }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const template = JSON.parse(staticPage[0].template)
  const seoMetaBlock = template.filter((item) => item.type === 'seometablock')

  useEffect(() => {
    setPageViewData('Content Page', 'Other', 'Content Page')
  }, [])

  const renderContent = () => {
    return template.map((staticPageContent) => {
      switch (staticPageContent.type) {
        case 'headerimage': {
          let headerImageDesktop, headerImageMobile
          // eslint-disable-next-line prefer-const
          [headerImageDesktop, headerImageMobile] = staticPageContent.value.split(',')
          return (
            <div className="staticpage__header-image">
              <GeneralImageHero image={headerImageDesktop} dynamicMediaUrl={staticPageContent.dynamicMediaUrl} dynamicMediaMobileUrl={staticPageContent.dynamicMediaMobileUrl} mobileImage={headerImageMobile} />
            </div>
          )
        }
        case 'headertitle':
          return <div className="staticpage__page-title staticpage__content-group"><PageTitle title={staticPageContent.value} /></div>
        case 'copy':
          return <div className="staticpage__content-group"><div dangerouslySetInnerHTML={{ __html: staticPageContent.value }} className='rte' /></div>
        case 'image':
          return <div className="image-next staticpage__content-group"><Image src={staticPageContent.value} tabIndex={0} className="staticpage__image" alt="arrow" fill loader={defaultLoader} /></div>
        case 'nestedimage':
          return <div className="staticpage__content-group"> <NestedImage nestedImageText={staticPageContent.text} nestedImageUrl={staticPageContent.imageUrl} dynamicMediaUrl={staticPageContent.dynamicMediaUrl}></NestedImage></div>
        case 'circleimage':
          return (
            <div className="image-next staticpage__content-group"><Image src={staticPageContent.value} tabIndex={0} className="staticpage__circle-image" alt="arrow" fill loader={defaultLoader} /></div>
          )
        case 'video':
          return (
            <div className="flex-video widescreen staticpage__video staticpage__content-group">
              <iframe src={staticPageContent.value}></iframe>
            </div>
          )
        default: return <div></div>
      }
    })
  }
  return (
    <div id="main-content" className="staticpage">
      <Head>
        <title>{seoMetaBlock[0]?.title || `Content Page ${fullUrl}/page/${slug}`}</title>
        <meta name="description" content={seoMetaBlock[0]?.description || `Content page for ${slug}`} />
        {slug === 'account-deletion' && <meta name="robots" content="noindex" />}
      </Head>
      <div className="staticpage__container">
        {Object.keys(staticPage[0]).length !== 0 && renderContent()}
      </div>
    </div>
  )
}

export default StaticPage

export const getServerSideProps = async ({ query, req }) => {
  const { publicRuntimeConfig } = getConfig()
  let fullUrl
  if (req) {
    fullUrl = req.headers.host + req.url
  } else {
    fullUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  }
  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/collections/${publicRuntimeConfig.ENV}/contentpage?slug=${query.slug}&popkey=${publicRuntimeConfig.POP_KEY}`,
    {
      headers: {
        popkey: publicRuntimeConfig.POP_KEY
      }
    }
  )

  const staticPage = await res.json()
  return {
    props: {
      staticPage,
      fullUrl,
      slug: query.slug
    }
  }
}
